import { ChangeDetectorRef, Component, Inject, Optional } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MovimientoDetailDto } from '@models/movimiento/movimientoDetailDto.model';
import { ComprobantesService } from '@services/comprobantes/comprobantes.service';
import { MovimientosService } from '@services/movimientos/movimientos.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogComprobanteComponent } from '@views/comprobantes/dialog-comprobante/dialog-comprobante.component';
import { ComprobanteVinculadoDto } from '@models/base/comprobanteVinculadoDto.model';

@Component({
  selector: 'app-dialog-view-movimiento',
  templateUrl: './dialog-view-movimiento.component.html',
  styleUrls: ['./dialog-view-movimiento.component.css'],
})
export class DialogViewMovimientoComponent {

  movimientoDetailDto!: MovimientoDetailDto

  comprobantesVinculados: ComprobanteVinculadoDto[] = []
  displayedColumnsComprobantes: string[] = ['tipoVinculo', 'nroComprobante', 'tipoComprobante', 'fechaEmision', 'estadoComprobante', 'importeImputado', 'accion'];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogViewMovimientoComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private movimientosService: MovimientosService,
    private comprobantesService: ComprobantesService,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.getMovimientoById()
    this.getComprobantesVinculados()
  }

  getMovimientoById() {
    this.spinner.show("spMovimiento")
    this.movimientosService.getById(this.data.id)
      .subscribe(
        data => {
          this.spinner.hide("spMovimiento")
          this.movimientoDetailDto = data
          this.changeDetectorRef.detectChanges()
        },
        error => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }

  getComprobantesVinculados() {
    this.movimientosService.getComprobantesVinculados(this.data.id)
      .subscribe(
        data => {
          this.comprobantesVinculados = data ?? []
          this.changeDetectorRef.detectChanges()
        },
        error => {
          this.snackBar.showError(error, "Error");
        })
  }

  /** Abre el comprobante vinculado en su propio diálogo */
  verComprobante(vinculo: ComprobanteVinculadoDto) {
    this.spinner.show("spMovimiento")
    this.comprobantesService.getById(vinculo.idComprobante)
      .subscribe(
        data => {
          this.spinner.hide("spMovimiento")

          const dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = false;
          dialogConfig.width = "70%";
          dialogConfig.data = data;

          this.dialog.open(DialogComprobanteComponent, dialogConfig);
        },
        error => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }

  /** Color del chip según de dónde viene el vínculo */
  colorVinculo(tipoVinculo: string): string {
    switch (tipoVinculo) {
      case 'Recibo origen': return 'primary';
      case 'Liquidación origen': return 'accent';
      default: return '';
    }
  }

  iconoVinculo(tipoVinculo: string): string {
    switch (tipoVinculo) {
      case 'Recibo origen': return 'receipt_long';
      case 'Liquidación origen': return 'account_balance_wallet';
      case 'Detalle': return 'list_alt';
      default: return 'description';
    }
  }

  trackByItems(index: number, item: any): any { return item; }
}
